export default __webpack_public_path__ + "static/media/dashboard-servizi.e87fbac6.png";